"use strict";

Shopify.theme.jsTestimonialsSlider = {
  init: function init($section) {
    var $testimonialsSliderEl = $(document).find('[data-testimonial-slider-v2]');
    var $testimonialsSlider = $testimonialsSliderEl.flickity({
      wrapAround: false,
      draggable: true,
      prevNextButtons: true,
      pageDots: true,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 70, y2: 40,
        x3: 30
      }
    });
    setTimeout(function () {
      $testimonialsSliderEl.flickity('resize');
    }, 500);
  },
  blockSelect: function blockSelect($section, blockId) {
    var $slider = $section.find('[data-testimonial-slider-v2]');
    var $sliderIndex = $('#shopify-section-' + blockId).data('data-slide-index');
    $slider.flickity('select', $sliderIndex, true, true);
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
};

